import React from 'react';
import PropTypes from 'prop-types';
import LoanAmount from '../components/LoanAmount';

const checkStatus = (status) => {
  let statusBool = false;
  switch (status) {
    case 'request_ctos_bad_request':
      statusBool = true;
      break;
    case 'request_ctos_muliple_entities':
      statusBool = true;
      break;
    default:
      statusBool = false;
  }
  return statusBool;
};

const CreditCheckScoreDSR = ({
  mCtosXMLStatusID,
  dsr,
  dsrScoreAfter,
  currentLoanAmount,
  netIncome,
}) => (
  <div className="score">
    <div>
      <h1>DSR</h1>
      {
        mCtosXMLStatusID !== 'dsr_generated' ?
          <div className={`${checkStatus(mCtosXMLStatusID) ? 'bad' : 'pending'} round icon`}>
            {
              checkStatus(mCtosXMLStatusID) ?
                <img alt="bad" src="/assets/images/icons/red_alert.svg" /> :
                <img alt="pending" src="/assets/images/icons/pending.svg" />
            }
          </div> :
          <div>
            <div className="success round icon">
              <span className="value">{dsr}<span className="value small">%</span></span>
            </div>
            <p style={{ marginTop: '1.2em' }}>
              This DSR % calculation is generated based on the Net Income you have declared.
            </p>
          </div>
      }
    </div>
    {
      currentLoanAmount > 0 ?
        <div style={{ marginTop: '3em' }}>
          <h1>DSR (After)</h1>
          {
            mCtosXMLStatusID !== 'dsr_generated' || (dsrScoreAfter && dsrScoreAfter <= 0) ?
              <div className={`${checkStatus(mCtosXMLStatusID) ? 'bad' : 'pending'} round icon`}>
                {
                  checkStatus(mCtosXMLStatusID) ?
                    <img alt="bad" src="/assets/images/icons/red_alert.svg" /> :
                    <img alt="pending" src="/assets/images/icons/pending.svg" />
                }
              </div> :
              <div>
                <div className="success round icon">
                  <span className="value">{dsrScoreAfter}<span className="value small">%</span></span>
                </div>
                <p style={{ marginTop: '1.2em' }}>
                  This DSR % calculation is generated based on the
                  &nbsp;Net Income and Housing Loan you have declared.
                </p>
              </div>
          }
        </div> :
        null
    }
    {
      mCtosXMLStatusID === 'dsr_generated' &&
        <div className="breakdown" style={{ height: 'auto' }}>
          {
            <table style={{ width: '100%', tableLayout: 'fixed' }}>
              <tbody>
                <tr>
                  <td>
                    <b>Net income :</b>
                  </td>
                  <td>
                    <LoanAmount
                      format="0,000,000.00"
                      amount={netIncome}
                      prefix="RM&nbsp;"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Housing loan amount :</b>
                  </td>
                  <td>
                    <LoanAmount
                      format="0,000,000.00"
                      amount={currentLoanAmount}
                      prefix="RM&nbsp;"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          }
        </div>
    }
  </div>
);

CreditCheckScoreDSR.propTypes = {
  mCtosXMLStatusID: PropTypes.string,
  dsr: PropTypes.number,
  dsrScoreAfter: PropTypes.number,
  currentLoanAmount: PropTypes.number,
  netIncome: PropTypes.number,
};

CreditCheckScoreDSR.defaultProps = {
  mCtosXMLStatusID: 'new',
  dsr: 0,
};

export default CreditCheckScoreDSR;



// WEBPACK FOOTER //
// ./src/components/CreditCheckScoreDSR.jsx